module.exports = __webpack_public_path__ + "img/Oak V2 960x540.33f331e9.png";